// @flow
import { connect } from 'react-redux';
import { createComponentId } from '~/core/utils/schedule';
import { getCurrentRecipe } from '~/core/state/recipes/selectors';
import RecipeSchedule from './component';
import { toggleScheduleState } from '~/core/state/recipes/actions';

const mapStateToProps = state => {
    const currentRecipe = getCurrentRecipe(state);
    const componentId = createComponentId('recipe', currentRecipe.getIn(['data', 'id']));
    return {
        isScheduled: currentRecipe.getIn(['data', 'scheduled'], false),
        scheduleComponentId: componentId
    };
};

const mapDispatchToProps = { toggleScheduleState };

export default connect(mapStateToProps, mapDispatchToProps)(RecipeSchedule);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-schedule/index.js